module.exports = __webpack_public_path__ + "static/media/podio-3rd.10015353.png";